module.exports = __webpack_public_path__ + "static/media/anatomia2.1a483495.png";